var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIosAttach2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6445 27.0011L27.9992 16.3984",
    stroke: "#99A1AF",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.334 8.00016L10.1153 19.4482C9.61542 19.9482 9.33458 20.6264 9.33458 21.3335C9.33458 22.0406 9.61542 22.7188 10.1153 23.2188C10.6154 23.7188 11.2936 23.9996 12.0007 23.9996C12.7078 23.9996 13.3859 23.7188 13.886 23.2188L25.1047 11.7708C26.1045 10.7707 26.6662 9.41437 26.6662 8.00016C26.6662 6.58595 26.1045 5.22964 25.1047 4.2295C24.1045 3.22965 22.7482 2.66797 21.334 2.66797C19.9198 2.66797 18.5635 3.22965 17.5633 4.2295L6.34334 15.6762C4.84293 17.1766 4 19.2116 4 21.3335C4 23.4554 4.84293 25.4904 6.34334 26.9908C7.84376 28.4912 9.87877 29.3342 12.0007 29.3342C14.1226 29.3342 16.1576 28.4912 17.658 26.9908",
    stroke: "#99A1AF",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosAttach2);
export default __webpack_public_path__ + "static/media/ios-attach2.9551cb43ecd6a32ef811f068a36ae456.svg";
export { ForwardRef as ReactComponent };